import { useAtom } from "jotai";
import React from "react";
import { Cursor } from "./Cursor";
import { BOT_NAME } from "../../consts";
import {
  audioStreamsAtom,
  onlinesAtom,
  videoStreamsAtom,
} from "../../jotai/atoms";
import { useUserInfos } from "../../liveblocks/maps";
import { usePresence } from "../../liveblocks/presences";
import { AnyBlock, Presence, User } from "../../types";
import { extractUserId } from "../../utils/session";

function CursorList({
  upsertBlock,
}: {
  upsertBlock: (block: Partial<AnyBlock>) => void;
}) {
  const [onlines] = useAtom(onlinesAtom);
  const [userInfos] = useUserInfos();
  const [videos] = useAtom(videoStreamsAtom);
  const [audios] = useAtom(audioStreamsAtom);
  const [stampModes] = usePresence<Presence["stampMode"]>("stampMode");
  const [cursors] = usePresence<Presence["cursor"]>("cursor");
  const [positions] = usePresence<Presence["position"]>("position");

  const videoByUid: Record<User["id"], MediaStreamTrack> = {};
  for (const sid in videos) {
    const uid = extractUserId(sid);
    if (uid) {
      videoByUid[uid] = videos[sid];
    }
  }

  const audioUids = new Set<User["id"]>();
  for (const sid in audios) {
    const uid = extractUserId(sid);
    if (uid) {
      audioUids.add(uid);
    }
  }

  if (!onlines || !userInfos) {
    return null;
  }

  return (
    <div aria-hidden={true}>
      {[...onlines].map((uid: string) => {
        const user = userInfos[uid];
        const isMuted = !audioUids.has(uid);

        if (!user || user.name === BOT_NAME) {
          return null;
        }

        return (
          <Cursor
            key={uid}
            userId={uid}
            stream={videoByUid[uid]}
            isMuted={isMuted}
            upsertBlock={upsertBlock}
            stampMode={stampModes[uid]}
            cursor={cursors[uid]}
            position={positions[uid]}
          ></Cursor>
        );
      })}
    </div>
  );
}

export default React.memo(CursorList);
